<template>
    <button
        class="dm-hidden-cypress-button-full"
        style="display: none"
        @click="presentation.full_uploaded = true"
    >
        Hidden Cypress Full Button
    </button>

    <div class="mb-8">
        <VueDropzone
            class="dropzone dropzone-default dz-clickable dz-started mb-4"
            :accepted_file_types="['application/pdf']"
            :max_file_size="maxFileSize"
            :upload_url="uploadFullUrl"
            @uploadSuccessful="replaceFullProps"
            @uploadFailedDueToFileTypes="showFileTypesError"
            @uploadFailedDueToFileSize="showFileSizeError"
            @uploadFailed="showSwalErrorPopup"
        >
            <div class="dropzone-msg dz-message needsclick">
                <h3 class="dropzone-msg-title">
                    {{ translate("Upload full manuscript here") }}
                </h3>
                <span class="dropzone-msg-desc d-block">{{
                    translate("We only receive .pdf files")
                }}</span>
                <span class="dropzone-msg-desc d-block">{{
                    translate("Maximum file size is 75MB")
                }}</span>
                <span class="dropzone-msg-desc d-block">{{
                    translate(
                        "Large files take long to load, so keep size to a minimum",
                    )
                }}</span>
            </div>
        </VueDropzone>

        <div
            v-if="presentation.full_uploaded"
            class="d-flex align-items-center dm-wizard-document-wrap"
        >
            <a
                download
                class="btn btn-sm btn-light"
                target="_blank"
                :href="presentation.full_url"
            >
                <i
                    class="las la-file-pdf ml-3 icon-xl"
                    v-if="presentation.full_extension == 'pdf'"
                ></i>
                <i class="las la-file-alt ml-3 icon-xl" v-else></i>
                {{ translate("Previously uploaded full manuscript") }}:
                <em>{{ presentation.full_file_name }}</em>
            </a>
            <button
                class="btn btn-xs btn-icon btn-light-danger ml-4 dm-small-close-button"
                @click="deleteFull()"
            >
                <i class="icon-xs las la-times"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";
import VueDropzone from "@/components/shared/VueDropzone.vue";

export default {
    components: { VueDropzone },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["presentation"]),

        maxFileSize() {
            return 75 * 1024 * 1024; // 75MB
        },

        uploadFullUrl() {
            return (
                "/api/author/presentations/" +
                this.presentation.id +
                "/documents/full"
            );
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["loadNavigation"]),

        replaceFullProps(data) {
            this.presentation.full_uploaded = data.full_uploaded;
            this.presentation.full_url = data.full_url;
            this.presentation.full_extension = data.full_extension;
            this.presentation.full_file_name = data.full_file_name;

            this.loadNavigation();
            this.showSwalSuccessPopup();
        },

        showFileTypesError() {
            this.showSwalErrorPopup("Please select only PDF files!");
        },

        showFileSizeError() {
            this.showSwalErrorPopup("Maximum file size is 75MB!");
        },

        deleteFull() {
            var self = this;
            axios.delete(this.uploadFullUrl).then(function (response) {
                self.replaceFullProps(response.data);
            });
        },
    },
};
</script>
